import { render } from "./Industria4_0.vue?vue&type=template&id=5ba10cab&scoped=true"
import script from "./Industria4_0.vue?vue&type=script&lang=js"
export * from "./Industria4_0.vue?vue&type=script&lang=js"

import "./Industria4_0.vue?vue&type=style&index=0&id=5ba10cab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba10cab"]])

export default __exports__